<template>
  <Card>
    <p slot="title"><Icon type="md-alert" />报表结算日管理</p>
    <template slot="extra"> </template>
    <Row>
      <Col span="24">
        <Input
          v-model="query.spCode"
          placeholder="资金商code"
          class="public-inp md5"
        />
        <Input
          v-model="query.name"
          placeholder="资金商名称"
          class="public-inp md5"
        />
        <!--      <span class="public-stretch" @click="open = !open">-->
        <!--                <Icon :type="open?'ios-arrow-up':'ios-arrow-down'"/>{{open?'收起':'展开'}}-->
        <!--                </span>-->
        <Button
          type="primary"
          icon="md-add"
          class="public-fr"
          @click="addFn()"
          v-access="'report.settle.add'"
          >添加结算日期</Button
        >
        <Button
          class="public-fr"
          @click="reset()"
          v-access="'report.settle.reset'"
          >重置</Button
        >
        <Button
          class="public-fr"
          type="primary"
          icon="ios-search"
          @click="getList()"
          v-access="'report.settle.query'"
          >查询</Button
        >
      </Col>
      <Col span="24">
        <Table
          :style="{ marginTop: '10px' }"
          border
          stripe
          :loading="loading"
          :columns="columns"
          :data="tbList"
        >
          <template slot-scope="{ row, index }" slot="sort">
            <span v-show="false">{{ row.code }}</span>
            {{ index + 1 }}
          </template>
          <template slot-scope="{ row }" slot="action">
            <a href="javascript:;" @click="editFn(row)">编辑</a>
          </template>
          <template slot-scope="{ row }" slot="status">
            <i-switch
              :value="row.status == 1"
              :before-change="beforeStateChange"
              @on-change="stateChange(row, $event)"
            />
          </template>
        </Table>
        <Page
          :style="{ float: 'right', marginTop: '10px' }"
          :total="total"
          show-sizer
          show-total
          prev-text="上一页"
          next-text="下一页"
          show-elevator
          @on-change="pageNumChange"
          @on-page-size-change="pageSizeChange"
        />
      </Col>
    </Row>
  </Card>
</template>
<script>
import columns from "@/views/task/columns";

export default {
  data() {
    return {
      visiable: false,
      open: false,
      query: {
        page: 1,
        rows: 10,
        name: "",
        spCode: "",
      },
      columns: [
        {
          title: "id",
          key: "id",
          width: 80,
          fixed: "left",
        },
        {
          title: "资金商code",
          key: "spCode",
          width: 150,
        },
        {
          title: "资金商名称",
          key: "spName",
          width: 250,
        },
        {
          title: "报表年份",
          key: "reportYear",
          width: 100,
        },
        {
          title: "报表月份",
          key: "reportMonth",
          width: 100,
        },
        {
          title: "结算日期",
          key: "settleDate",
          width: 170,
        },
        {
          title: "创建时间",
          key: "createtime",
          width: 150,
          fixed: "right",
        },
        {
          title: "更新时间",
          key: "updatetime",
          width: 150,
          fixed: "right",
        },
        // , {
        //   title: '操作',
        //   slot: 'action',
        //   width: 70,
        //   fixed: 'right'
        // }
      ],
      tbList: [],
      loading: false,
      total: 0,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let data = this.query;
      this.loading = true;
      this.$api.getAllSpSettleDateList(data).then((res) => {
        this.loading = false;
        if (res.code == "200") {
          this.tbList = res.data;
          this.total = res.total;
        }
      });
    },
    reset() {
      this.query.spCode = "";
      this.query.name = "";
      this.$nextTick(() => {
        this.getList();
      });
    },
    uploadToggle() {
      this.visiable = !this.visiable;
    },
    // 页码
    pageNumChange(pageNum) {
      this.query.page = pageNum;
      this.getList();
    },
    // 页数
    pageSizeChange(pageSize) {
      this.query.rows = pageSize;
      // 页码变动触发pageNumChange
      if (this.query.page == 1) {
        this.getList();
      } else {
        this.query.page = 1;
      }
    },
    addFn() {
      this.$router.push({
        name: "addSettle",
      });
    },
    editFn(row) {
      this.$router.push({
        name: "spInfoAdd",
        query: {
          id: row.id,
        },
      });
    },
    beforeStateChange() {
      return new Promise((resolve, reject) => {
        this.$Modal.confirm({
          title: "切换确认",
          content: "您确认要切换状态吗？",
          onOk: resolve,
          oncancel: reject,
        });
      });
    },
    stateChange(d, v) {
      if (v) {
        this.$api.enableReportSpMeta({ id: d.id }).then((res) => {
          if (res.code == "200") {
            this.$Message.success("启用成功");
            this.getList();
          } else {
            this.$Message.error("启用失败");
          }
        });
      } else {
        this.$api.disableReportSpMeta({ id: d.id }).then((res) => {
          if (res.code == "200") {
            this.$Message.success("禁用成功");
            this.getList();
          } else {
            this.$Message.error("禁用失败");
          }
        });
      }
    },
  },
};
</script>
<style scoped>
.md5 {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/report/settleDate.vue